'use client'

import { useEffect, useState } from 'react'

export const useMounted = (): boolean => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])
  return mounted
}
